import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle2, Sparkles, Clock, ArrowRight } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { Button } from '../../components/ui/Button';
export function CompletionConfirmationPage() {
  const {
    t
  } = useLanguage();
  const navigate = useNavigate();
  useEffect(() => {
    // Auto-redirect after 5 seconds
    const timer = setTimeout(() => {
      navigate('/fornitore');
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate]);
  return <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" data-id="element-775">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} transition={{
      type: 'spring',
      damping: 20,
      stiffness: 300
    }} className="max-w-md w-full" data-id="element-776">
        {/* Success Icon with Animation */}
        <motion.div initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        delay: 0.2,
        type: 'spring',
        damping: 15,
        stiffness: 200
      }} className="flex justify-center mb-6" data-id="element-777">
          <div className="w-24 h-24 bg-teal-deep rounded-full flex items-center justify-center shadow-lg" data-id="element-778">
            <CheckCircle2 className="w-14 h-14 text-white" strokeWidth={2.5} data-id="element-779" />
          </div>
        </motion.div>

        {/* Main Content */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="text-center mb-8" data-id="element-780">
          <h1 className="text-3xl font-bold text-navy mb-3" data-id="element-781">
            Grazie per il tuo lavoro!
          </h1>
          <p className="text-lg text-gray-600 mb-2" data-id="element-782">
            L'intervento è stato completato con successo
          </p>
          <p className="text-sm text-gray-500" data-id="element-783">
            Le foto sono state caricate e verranno analizzate dal sistema
            CleanAI
          </p>
        </motion.div>

        {/* Info Cards */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6
      }} className="space-y-3 mb-8" data-id="element-784">
          <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-200 flex items-center gap-3" data-id="element-785">
            <Sparkles className="w-5 h-5 text-gray-600 flex-shrink-0" data-id="element-786" />
            <div className="flex-1" data-id="element-787">
              <p className="text-sm font-semibold text-navy" data-id="element-788">
                Analisi AI in corso
              </p>
              <p className="text-xs text-gray-500" data-id="element-789">Verifica qualità pulizia</p>
            </div>
          </div>

          <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-200 flex items-center gap-3" data-id="element-790">
            <Clock className="w-5 h-5 text-gray-600 flex-shrink-0" data-id="element-791" />
            <div className="flex-1" data-id="element-792">
              <p className="text-sm font-semibold text-navy" data-id="element-793">
                Pagamento in elaborazione
              </p>
              <p className="text-xs text-gray-500" data-id="element-794">
                Riceverai conferma a breve
              </p>
            </div>
          </div>
        </motion.div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8
      }} data-id="element-795">
          <Button onClick={() => navigate('/fornitore')} className="w-full bg-teal-deep hover:bg-teal-700" data-id="element-796">
            Torna alla Home
            <ArrowRight className="w-5 h-5 ml-2" data-id="element-797" />
          </Button>
          <p className="text-xs text-center text-gray-400 mt-3" data-id="element-798">
            Reindirizzamento automatico tra 5 secondi...
          </p>
        </motion.div>
      </motion.div>
    </div>;
}